import React, { useState, useEffect } from "react";

import ArticleModal from "./ArticleModal";
import UrlFilterHelper from "./UrlFilterHelper";
import FileDownloadModal from "./FileDownloadModal";
import Spinner from "./Spinner";

import AdditionalColumnTHs from "./AdditionalColumns/AdditionalColumnTHs";
import AdditionalColumnTDs from "./AdditionalColumns/AdditionalColumnTDs";
import MandatoryColumnTHs from "./MandatoryColumns/MandatoryColumnTHs";
import MandatoryColumnTDs from "./MandatoryColumns/MandatoryColumnTDs";
import FilterGroupColumnTHs from "./FilterGroupColumns/FilterGroupColumnTHs";
import FilterGroupColumnTDs from "./FilterGroupColumns/FilterGroupColumnTDs";
import HardcodedStartColumnTHs from "./HardcodedColumns/HardcodedStartColumnTHs";
import HardcodedStartColumnTDs from "./HardcodedColumns/HardcodedStartColumnTDs";
import HardcodedEndColumnTHs from "./HardcodedColumns/HardcodedEndColumnTHs";
import HardcodedEndColumnTDs from "./HardcodedColumns/HardcodedEndColumnTDs";
import { enrichProductVariantProperties } from "./SchemaOrgGraph";

import { mandatoryColumns } from "../constants/static";

const ArticleListing = (props) => {
    const [state, setState] = useState({
        sortProperty: "",
        sortType: "asc",
        showModal: false,
        fileDownloadModalOpen: false,
        fileDownloadUrl: "",
        fileDownloadSelectedArticleName: "",
        selectedSeries: "",
        selectedArticle: null,
    });

    const filterHelper = new UrlFilterHelper();

    useEffect(() => {
        getQueryArticle();
    }, [props.articles]);

    const onClick = (selectedArticle) => {
        enrichProductVariantProperties(selectedArticle);
        setState((prevState) => ({ ...prevState, selectedArticle }));
        filterHelper.setQueryStringValue("am", selectedArticle.code);

        if (window.location.hash !== "#parts") {
            window.location.hash = "#parts";
        }

        showArticleModal();
    };

    const closeDownloadModal = () => {
        setState((prevState) => ({ ...prevState, fileDownloadModalOpen: false }));
        document.body.style.overflow = "inherit";
    };

    const getQueryArticle = async () => {
        if (props.articles) {
            const authResult = new URLSearchParams(window.location.search);
            const articleName = authResult.get("am");

            if (articleName !== undefined) {
                var queryArticle =
                    props.articles.filter(function (item) {
                        return item.name == articleName;
                    })[0] || null;

                if (queryArticle !== null) {
                    enrichProductVariantProperties(queryArticle);
                    setState((prevState) => ({ ...prevState, showModal: true, selectedArticle: queryArticle }));
                    document.body.style.overflow = "hidden";
                } else if (queryArticle === null) {
                    document.body.style.overflow = "inherit";
                }
            }
        }
        return;
    };

    const openDownloadModal = (url, article) => {
        setState((prevState) => ({
            ...prevState,
            fileDownloadModalOpen: true,
            fileDownloadUrl: url,
            fileDownloadSelectedArticleName: article.name,
        }));
        document.body.style.overflow = "hidden";
    };

    const showArticleModal = () => {
        if (state.showModal === false) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "inherit";
        }

        setState((prevState) => ({ ...prevState, showModal: !prevState.showModal }));
    };

    const toggleSort = () => {
        setState((prevState) => ({ ...prevState, sortType: prevState.sortType === "asc" ? "desc" : "asc" }));
    };

    const changeSortProperty = (data) => {
        if (!data.id && data !== "code" && data !== mandatoryColumns.ItemCategoryTitle) {
            return;
        }

        if (data.id) {
            if (state.sortProperty === data.id) {
                toggleSort();
                return;
            }

            if (state.sortProperty === "" || state.sortProperty !== data.id) {
                setState((prevState) => ({ ...prevState, sortProperty: data.id, sortType: "asc" }));
                return;
            }
        } else {
            if (state.sortProperty === data) {
                toggleSort();
                return;
            }

            if (state.sortProperty === "" || state.sortProperty !== data) {
                setState((prevState) => ({ ...prevState, sortProperty: data, sortType: "asc" }));
                return;
            }
        }
    };

    return (
        <>
            {props.articles?.length > 0 && (
                <ArticleTable
                    additionalTableColumns={props.additionalTableColumns}
                    articles={props.articles}
                    filterGroups={props.filterGroups}
                    onFilterSelected={props.onArticleFilterSelected}
                    onClick={onClick}
                    totalMatching={props.totalMatching}
                    closeDownloadModal={closeDownloadModal}
                    openDownloadModal={openDownloadModal}
                    open={state.fileDownloadModalOpen}
                    fileUrl={state.fileDownloadUrl}
                    fileDownloadSelectedArticleName={state.fileDownloadSelectedArticleName}
                    selectedSeries={props.selectedSeries}
                    showResultBar={props.showResultBar}
                    toggleSort={toggleSort}
                    changeSortProperty={changeSortProperty}
                    sortProperty={state.sortProperty}
                    sortType={state.sortType}
                />
            )}

            {state.selectedArticle && (
                <ArticleModal
                    series={props.series}
                    showModal={state.showModal}
                    selectedArticle={state.selectedArticle}
                    onClose={showArticleModal}
                    filterGroups={props.filterGroups}
                    selectedSeries={props.selectedSeries}
                    footNoteData={props.footNoteData}
                />
            )}
        </>
    );
};

const ArticleTable = (props) => {
    let sortedArticles = [...props.articles];

    if (props.sortProperty !== "") {
        if (props.sortProperty === "code") {
            sortedArticles = props.articles.sort((a, b) => {
                return props.sortType === "asc"
                    ? (a.code > b.code) - (a.code < b.code)
                    : (a.code < b.code) - (a.code > b.code);
            });
        } else {
            sortedArticles = props.articles.sort((a, b) => {
                var str1 = a.dataCollection.filter((x) => x.fieldName === props.sortProperty)[0]?.fieldValue;
                var str2 = b.dataCollection.filter((x) => x.fieldName === props.sortProperty)[0]?.fieldValue;

                return props.sortType === "asc" ? (str1 > str2) - (str1 < str2) : (str1 < str2) - (str1 > str2);
            });
        }
    }

    return (
        <>
            <div className="c-parts-listing">
                {props.showResultBar ? (
                    <>
                        <div className="article-listing-result mt-5">
                            <p className="m-0 show">
                                {props.totalMatching} {i18n.getString("articlelisting.itemsmatching")}
                            </p>

                            <Spinner />
                        </div>
                    </>
                ) : null}

                {props.totalMatching === 0 && props.articles.length === 0 ? null : (
                    <table className="c-parts-listing__table">
                        <tbody>
                            <tr className="c-parts-listing__table-row">
                                {/* Hardcoded Start THs */}
                                <HardcodedStartColumnTHs
                                    sortType={props.sortType}
                                    sortProperty={props.sortProperty}
                                    changeSortProperty={props.changeSortProperty}
                                />

                                {/* Mandatory column THs */}
                                <MandatoryColumnTHs
                                    collection={props.articles[0]?.dataCollection}
                                    sortType={props.sortType}
                                    sortProperty={props.sortProperty}
                                    changeSortProperty={props.changeSortProperty}
                                />

                                {/* Additional column THs */}
                                <AdditionalColumnTHs
                                    columns={props.additionalTableColumns}
                                    changeSortProperty={props.changeSortProperty}
                                    sortProperty={props.sortProperty}
                                    sortType={props.sortType}
                                />

                                {/* Filtergroup column THs */}
                                <FilterGroupColumnTHs
                                    filterGroups={props.filterGroups}
                                    changeSortProperty={props.changeSortProperty}
                                    sortProperty={props.sortProperty}
                                    sortType={props.sortType}
                                />

                                {/* Hardcoded End THs */}
                                <HardcodedEndColumnTHs />
                            </tr>

                            {/* Mapping sorted articles */}
                            {sortedArticles?.map((row, index) => {
                                return (
                                    <tr className="c-parts-listing__table-row" key={row.name}>
                                        {/* Hardcoded Start TDs */}
                                        <HardcodedStartColumnTDs row={row} onClick={() => props.onClick(row)} />

                                        {/* Mandatory column TDs */}
                                        <MandatoryColumnTDs
                                            articles={sortedArticles}
                                            collection={row.dataCollection}
                                            index={index}
                                        />

                                        {/* Additional column TDs */}
                                        <AdditionalColumnTDs
                                            columns={props.additionalTableColumns}
                                            collection={row.dataCollectionGroupedByFieldName}
                                        />

                                        {/* Filtergroup TDs */}
                                        <FilterGroupColumnTDs
                                            filterGroups={props.filterGroups}
                                            collection={row.dataCollectionGroupedByFieldName}
                                        />

                                        {/* Hardcoded end TDs */}
                                        <HardcodedEndColumnTDs openDownloadModal={props.openDownloadModal} row={row} />
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                )}
            </div>

            <FileDownloadModal
                open={props.open}
                fileUrl={props.fileUrl}
                fileDownloadSelectedArticleName={props.fileDownloadSelectedArticleName}
                onClose={props.closeDownloadModal}
            />
        </>
    );
};

export default ArticleListing;
